import React from "react";
import { useLocation, Link } from "react-router-dom";

const OrderConfirmationPage = () => {
    const location = useLocation();
    const { message, order } = location.state || {};

    if (!order) {
        return <p>No order information available.</p>;
    }

    return (
        <div className="container mx-auto p-6 bg-white shadow-md rounded-lg">
            <h1 className="text-3xl font-semibold text-center mb-6">Order Confirmation</h1>
            <p className="text-center text-lg mb-4">{message}</p>

            <div className="mb-6">
                <h2 className="text-2xl font-semibold text-center mb-4">Your Order ID: <span className="font-bold">{order._id}</span></h2>
                <h3 className="text-xl font-semibold mb-2">Items Purchased:</h3>
                <div className="space-y-4">
                    {order.items.map((item) => (
                        <div key={item.pid} className="flex items-center border-b py-2">
                            <img src={item.cover} alt={item.title} className="w-16 h-16 object-cover mr-4" />
                            <div className="flex-grow flex justify-between">
                                <h4 className="text-lg font-medium">{item.title}</h4>
                                <div className="flex items-center">
                                    <span className="mr-2">Quantity: {item.quantity}</span>
                                    <span className="font-medium">${(item.quantity * item.price).toFixed(2)}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="mb-6">
                <h3 className="text-xl font-semibold mb-2">Order Details:</h3>
                <div className="flex justify-between mb-2">
                    <span>Order Date:</span>
                    <span>{new Date(parseInt(order.createdAt)).toLocaleString()}</span>
                </div>
                <div className="flex justify-between mb-2">
                    <span>Subtotal:</span>
                    <span>${order.subTotal.toFixed(2)}</span>
                </div>
                <div className="flex justify-between mb-2">
                    <span>Tax:</span>
                    <span>${order.tax.toFixed(2)}</span>
                </div>
                <div className="flex justify-between mb-2">
                    <span>Shipping:</span>
                    <span>${order.shipping.toFixed(2)}</span>
                </div>
                <div className="flex justify-between font-bold text-lg">
                    <span>Grand Total:</span>
                    <span>${order.grandTotal.toFixed(2)}</span>
                </div>
                <div className="flex justify-between mb-2">
                    <span>Payment Method:</span>
                    <span>{order.paymentMethod}</span>
                </div>
            </div>

            <div className="text-center">
                <Link to="/" className="mt-4 inline-block bg-blue-500 text-white py-2 px-6 rounded-lg hover:bg-blue-700 transition-all duration-300">
                    Go to Homepage
                </Link>
            </div>
        </div>
    );
};

export default OrderConfirmationPage;

